import { t } from 'i18next';

import { Box } from '@mui/system';
import {
  Card,
  CardHeader,
  CardContent
} from '@mui/material';

import { TaskLinkedEntityType } from 'src/services/tasks/tasks.types';
import PostCommentForm from 'src/layouts/common/threads/post-comment-form';
import PostCommentList from 'src/layouts/common/threads/post-comment-list';
import { useGetCompanyByIdQuery } from "src/services/connections/connections.service";

import Iconify from 'src/components/iconify';

import LinkedTasks from 'src/sections/tasks/components/linked-tasks';

type Props = {
  companyProfileId: string;
};


export const CompanyDetailSection = ({ companyProfileId }: Props) => {
  const { data: companyProfile } = useGetCompanyByIdQuery({ profile_id: companyProfileId }, {
    skip: !companyProfileId,
  });

  if (!companyProfile?.thread?.id) {
    return null;
  }

  return (
    <Card>
      <CardHeader
        title={
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <Iconify icon="uil:notes" />
            <Box>{t('companies.profile.thread.title')}</Box>
          </Box>
        }
      />
      <CardContent>
        <PostCommentForm thread_id={companyProfile.thread.id} />
        <LinkedTasks entityType={TaskLinkedEntityType.COMPANY_PROFILE} entityId={companyProfileId} />
        {/* JT1-1736: merged with the notes on the deals this company is linked to */}
        <PostCommentList feed={{ type: 'company', id: companyProfileId }} />
      </CardContent>
    </Card>
  )
};